import React, { useEffect, useState } from "react";
import { Button, Grid, CircularProgress } from "@material-ui/core";
import Templater from "../../../components/Templater";
import SomaStatus from "../../../components/SomaStandard/SomaStatus";
import { toast } from "react-toastify";
import SomaPlaceService from "../../../Services/SomaPlace/index";
import { parseFontSizeContract } from "../util/parsers";

const Contrato = (props) => {
  const [status, setStatus] = useState("wait");
  const [contrato, setContrato] = useState({});
  const [loading,setLoading] = useState(false);
  const getPdf = async () => {
    let pdf;
    if (props.mode === "view") {
      pdf = await SomaPlaceService.SomaPlace.getContractPdfById(props.contrato.id);
    } else {
      pdf = await SomaPlaceService.SomaPlace.getContractPdf();
    }

    const file = new Blob([pdf.data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  useEffect(() => {
    if (props.mode !== "view") {
      const onCancel = props.onCancel;
      setStatus("wait");
      (async () => {
        const data = await SomaPlaceService.SomaPlace.getCurrentContract();
        const contrato = data.data;
        if (!contrato) {
          toast.error("Cadastro Não Realizado - Contrato indisponivel");
          onCancel();
        }

        setContrato(parseFontSizeContract(contrato));
        setStatus("result");
      })();
    } else {
      setContrato(parseFontSizeContract(props.contrato.content));
      setStatus("result");
    }
  }, [props.onCancel, props.mode, props.contrato]);
  return (
    <SomaStatus status={status}>
      <Grid container direction={"column"} justify="center" alignItems="flex-end">
        <Grid item style={{ margin: "10px" }}>
          <Templater template={contrato} />
        </Grid>
        <Grid item>
          <Button
            onClick={() => props.onCancel()}
            color={"primary"}
            variant={"outlined"}
            style={{ fontWeight: 600, margin: "0px 20px" }}
          >
            Voltar
          </Button>
          {props.mode !== "view" &&  (
            <Button
              onClick={() => {setLoading(true) ;props.aceito(contrato)}}
              color={"primary"}
              variant={"contained"}
              disabled={loading}
              style={{ color: "white", fontWeight: 600 }}
            >
             { !loading ? 
              ' Li e Aceito' : 
              (<CircularProgress color='secondary' size={24} />) 
             } 
            </Button>
          ) 
        }
          <Button
            onClick={() => getPdf()}
            color={"primary"}
            variant={"outlined"}
            style={{ fontWeight: 600, margin: "0px 20px" }}
          >
            Baixar PDF
          </Button>
        </Grid>
      </Grid>
    </SomaStatus>
  );
};

export default Contrato;
